import { ACTIVATION_USER} from "../../../api/apiRoutes";
import useFacility from "../../../../utils/hooks/useFacility";
import useApiRequest from "../../../../utils/hooks/useApiRequest";

export default function useActivationUser() {
  const facilityIds = useFacility();
  const { get } = useApiRequest();
  const activateUser = async (token: string, ids: string) => {
    const { result, isError } = await get(ACTIVATION_USER(token, ids));
  };

  return {
    activateUser
  };
}
